import { render, staticRenderFns } from "./add-unidades.vue?vue&type=template&id=1a6eafc4&"
import script from "./add-unidades.vue?vue&type=script&lang=js&"
export * from "./add-unidades.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports